<div class="flex flex-col h-full">
  <div class="p-8 flex flex-row justify-between items-center bg-primary-600 text-contrast rounded-t-md">
    <h2 class="m-0">{{ { key: 'onlineBooking' } | i18n }}</h2>
    <button class="flex flex-row justify-center items-center" (click)="close()">
      <ng-icon name="heroXMark" class="h-5 w-5 flex-shrink-0" size="24px"></ng-icon>
    </button>
  </div>
  <div class="rounded-b-md shadow-md bg-white p-8 w-full flex flex-col h-auto overflow-auto">
    @switch (displayMode()) {
      @case ('hasPendingApprovalRequest') {
        <p>{{ { key: 'approvalInProgress' } | i18n }}</p>
        <p>{{ { key: 'weWillContactYou' } | i18n }}</p>
        <!-- <button
        class="mt-8 w-full items-center justify-center border border-transparent bg-primary-600 py-2 px-4 text-sm font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 focus:ring-offset-gray-50"
        (click)="login()"
      >
        Anmelden
      </button> -->
      }
      @case ('loggedOut') {
        <p>{{ { key: 'alreadyHaveAccount' } | i18n }}</p>
        <p>{{ { key: 'pleaseLoginToContinue' } | i18n }}</p>
        <button
          class="mt-8 w-full items-center justify-center border border-transparent bg-primary-600 py-2 px-4 text-sm font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 focus:ring-offset-gray-50"
          (click)="login()"
        >
          {{ { key: 'login' } | i18n }}
        </button>
      }
      @case ('notVerified') {
        @if (meta.isLoading() || isUploading()) {
          <app-loading></app-loading>
        } @else if (meta.value()) {
          <p class="text-sm">
            {{ { key: 'additionalInfoRequired' } | i18n }}
          </p>

          @for (step of fileSteps; track step._id) {
            <div class="mt-4 pt-4 border-t border-gray-300 text-sm">
              <div class="flex flex-row justify-between items-center">
                <h3 class="mb-0">{{ step.title }}</h3>
                @if (isDone(step)) {
                  <ng-icon name="heroCheckCircle" size="24px" class="text-green-700"></ng-icon>
                }
              </div>

              @if (currentStep() === $index) {
                <p class="text-sm mt-4 whitespace-pre-line" [innerHTML]="step.description"></p>
                @switch (step.input) {
                  @case (PlaceBookingStepInput.FILE) {
                    <div class="mt-4 cursor-pointer text-sm">
                      <!-- <span class="block text-sm leading-6 text-gray-900 font-bold mb-2">Datei hochladen</span> -->
                      <label (drop)="uploadFile($event, step.fileType)" (dragover)="dragOver($event)" (dragleave)="dragLeave($event)">
                        <div
                          class="mt-2 flex justify-center rounded-lg border border-dashed border-gray-900/25 px-6 py-10 bg-opacity-25 cursor-pointer"
                        >
                          {{ { key: 'dragOrClickToUpload' } | i18n }}
                        </div>
                        <input class="sr-only" type="file" (change)="uploadFile($event, step.fileType)" />
                      </label>
                    </div>
                  }
                  @case (PlaceBookingStepInput.OPTIONAL_MULTI_FILE) {
                    <app-know-how-upload [fileType]="step.fileType" (reload)="meta.reload()"></app-know-how-upload>
                    <div class="mt-4 flex flex-row justify-end">
                      <button
                        class="items-center justify-center border border-transparent py-2 px-4 text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-600 focus:ring-offset-2"
                        (click)="step.filesUploadedSignal.set(true)"
                      >
                        {{
                          { key: 'noMoreFiles', values: [(meta.value()?.files?.[step.fileType]?.length || 0) === 0 ? ' ' : ' weitere '] }
                            | i18n
                        }}
                      </button>
                    </div>
                  }
                  @case (PlaceBookingStepInput.TERMS) {
                    <a [href]="step.url" target="_blank" class="text-sm underline">{{ { key: 'clickHereToViewFile' } | i18n }}</a>
                    <div class="mt-4 flex flex-row justify-end">
                      <button
                        class="items-center justify-center border border-transparent py-2 px-4 text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-600 focus:ring-offset-2"
                        (click)="step.signal.set(true)"
                      >
                        {{ { key: 'iAgree' } | i18n }}
                      </button>
                    </div>
                  }
                  @case (PlaceBookingStepInput.SUBMIT) {
                    <textarea
                      rows="4"
                      name="possible-dates"
                      id="possible-dates"
                      class="block w-full border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary-600 text-sm"
                      placeholder="{{ { key: 'enterPossibleDates' } | i18n }}"
                      [(ngModel)]="possibleDates"
                    ></textarea>
                    <div class="mt-4 flex flex-row justify-end">
                      <button
                        class="items-center justify-center border border-transparent py-2 px-4 text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-600 focus:ring-offset-2"
                        (click)="submit()"
                      >
                        {{ { key: 'completeRegistration' } | i18n }}
                      </button>
                    </div>
                  }
                }
              }
            </div>
          }
        }
      }
    }
  </div>
</div>
